function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-reallocate-reassign_svg__cls-1{fill:var(--main-color)}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon-reallocate-reassign_svg__Layer_1",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon-reallocate-reassign_svg__cls-1",
  d: "M199.09 62.21a4.6 4.6 0 014.6 4.59v130.81a4.61 4.61 0 01-4.6 4.6H68.28a4.6 4.6 0 01-4.59-4.6V66.8a4.6 4.6 0 014.59-4.59h130.81m0-8H68.28A12.59 12.59 0 0055.69 66.8v130.81a12.6 12.6 0 0012.59 12.6h130.81a12.6 12.6 0 0012.6-12.6V66.8a12.59 12.59 0 00-12.6-12.59z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-reallocate-reassign_svg__cls-1",
  d: "M137.69 206.21v-148h61.4a8.6 8.6 0 018.6 8.59v130.81a8.61 8.61 0 01-8.6 8.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-reallocate-reassign_svg__cls-1",
  d: "M199.09 62.21a4.6 4.6 0 014.6 4.59v130.81a4.61 4.61 0 01-4.6 4.6h-57.4v-140h57.4m0-8h-65.4v156h65.4a12.6 12.6 0 0012.6-12.6V66.8a12.59 12.59 0 00-12.6-12.59z"
}), /*#__PURE__*/React.createElement("path", {
  strokeMiterlimit: 10,
  stroke: "var(--main-color)",
  fill: "none",
  strokeWidth: 18,
  d: "M84.69 132.21h49"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  stroke: "#fff",
  fill: "none",
  strokeWidth: 18,
  d: "M133.69 132.21h44"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  strokeWidth: 8,
  fillRule: "evenodd",
  stroke: "#fff",
  strokeMiterlimit: 10,
  d: "M168.69 119.04l-.43 26.48 22.11-11.27-21.68-15.21z"
}));

function SvgIconReallocateReassign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 259 259"
  }, props), _ref, _ref2);
}

export default SvgIconReallocateReassign;